import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digital-landscape',
  templateUrl: './digital-landscape.component.html',
  styleUrls: ['./digital-landscape.component.sass']
})
export class DigitalLandscapeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
